import { useEffect, useState } from "react";
import { Header } from "../../../components/header/header";
import { PageLoader } from "../../../components/loader/pageLoader";
import { useLocation, useParams } from "react-router";
import { Button } from "../../../components/button/button";
import { ProgressLine } from "../../../components/progressLine/progressLine";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { UploadIcon } from "../../../assets/icons";
import { ImageGrid } from "../../../components/imageGrid/imageGrid";
import { UploadFiles } from "../../../components/uploadFiles/uplodeFiles";
import CheckListAPI from "../../../api/CheckListAPI";
import qs from "qs";

import styles from "./checklistTaskPage.module.css";

import { RawTextEditor } from "../../../components/rawTextEditor/rawTextEditor";
import { Separator } from "../../../components/separator/separator";

import { Text } from "../../../components/text/text";

const priorities = ["низкий", "средний", "высокий"];

export const ChecklistTaskPage = () => {
    const MAX_FILES = 5;

    const { taskId } = useParams();

    const [taskData, setTaskData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [images, setImages] = useState([]);
    const [newImages, setNewImages] = useState([]);

    const [text, setText] = useState("");

    const { search } = useLocation();
    const tabId = qs.parse(search.replace("?", "")).initialTab || "bar";

    useEffect(() => {
        CheckListAPI
            .fetchTaskData(taskId)
            .catch(console.error)
            .then(data => {
                setTaskData(data);
                if (data.note) {
                    setText(data.note);
                }
                return CheckListAPI.fetchTaskImages(taskId);
            })
            .catch(console.error)
            .then(setImages)
            .finally(() => setLoading(false));
    }, [taskId]);

    const [uploading, setUploading] = useState(false);
    const uploadFiles = async () => {
        setUploading(true);
        if (newImages && newImages.length > 0) {
            try {
                const uploaded = await Promise.all(Array.from(newImages).splice(0, Math.max(0, MAX_FILES - images.length)).map(file => {
                    return CheckListAPI.uploadTaskImage(taskId, file);
                }));

                setImages(prev => [...prev, ...uploaded]);
            } catch (error) {
                console.error(error);
            }
        }

        setNewImages([]);
        setUploading(false);
    }

    const navigate = useAnimatedNavigate();
    const onSave = async () => {
        if (text !== taskData.note) {
            try {
                await CheckListAPI.changeNote(taskData.id, taskData.taskType, text);
            } catch (error) {
                console.error(error);
            }
        }

        await uploadFiles();

        navigate(`/checklist?initialTab=${tabId}&scrollToTaskId=${taskId}`);
    }

    const onDeleteImage = (id) => {
        CheckListAPI
            .deleteTaskImage(id)
            .then(() => {
                setImages(prev => prev.filter(data => data.id !== id));
            })
            .catch(console.error);
    }

    if (loading || taskData === null) {
        return <PageLoader />;
    }

    return (
        <>
            <Header title={
                <div className={styles.title}>
                    <span>Задача</span>
                    <ProgressLine progress={0.1 + 0.9 * (taskData.countDone / taskData.countTotal)} height="4px" />
                </div>
            } />

            <div className={styles.task}>
                <div className={styles.task_description}>
                    Статус: {
                        taskData.countTotal === 1 ?
                            (taskData.countDone === taskData.countTotal ? "выполнено" : "не выполнено") :
                            (`выполнено ${taskData.countDone} / ${taskData.countTotal}`)
                    } <br />
                    Приоритет: {priorities[taskData.priority]}
                </div>
                <Text as="div" variant="body" className={styles.task_text} size={16} weight={700} lineHeight="1.1">
                    {taskData.taskText}
                </Text>
            </div>

            <RawTextEditor
                label="Заметки"
                value={text}
                setValue={setText}
            />

            <div className={styles.images_container}>
                <Text as="div" variant="h3" className={styles.images_title} size={12}>Изображения (максимум {MAX_FILES} файлов)</Text>
                <div className={styles.upload_images}>
                    <UploadFiles
                        disabled={uploading}
                        selectedFiles={newImages}
                        setSelectedFiles={setNewImages}
                        accept="image/*"
                        />
                    <Button
                        disabled={uploading || images.length >= MAX_FILES}
                        icon={<UploadIcon />}
                        type="secondary"
                        onClick={uploadFiles}
                    />
                </div>
                <ImageGrid
                    images={images}
                    onDelete={onDeleteImage}
                />
            </div>

            <Separator />

            <Button
                fixed
                text="Сохранить и вернуться к задачам"
                onClick={onSave}
            />
        </>
    );
}